import { Component, OnInit, ElementRef, ViewChild, EventEmitter, Input } from '@angular/core';
// import * as traducaoDatatable from '../../../../assets/plugins/datatable-translate/pt-BR.json';
import { UtilsService } from 'src/app/@core/@service/utils/utils';
import { CadastroCargoUnidadeService } from 'src/app/@core/@service/cadastro/cargo/unidade/unidade.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cargo-unidade',
  templateUrl: './unidade.component.html',
  styleUrls: ['./unidade.component.scss']
})
export class CargoUnidadeComponent implements OnInit {

  gridData = [];

  isEdit = false;

  unidadeIdSelected = '';

  dataTable: any;

  @ViewChild('grid', { static: true }) grid: ElementRef;

  constructor(
    private utilService: UtilsService,
    private moduleService: CadastroCargoUnidadeService,
  ) { }

  ngOnInit() {
    this.getIntitialsData();
    this.validarCampos();
  }

  async remover(data) {
    Swal.fire({
      position: 'top',
      title: 'Você tem certeza que deseja remover esse registro?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3c8dbc',
      cancelButtonColor: '#DD4B39',
      cancelButtonText: 'Não',
      confirmButtonText: 'Sim'
    }).then((result) => {
      if (result.isConfirmed) {
        this.moduleService.remover(data).subscribe(
          res => {
            this.utilService.alertSwal('remove-success');
            this.getDataGrid();
          },
          err => {
            this.utilService.alertSwal('remove-error');
          }
        );
      }
    })
  }


 validarCampos() {
  ($("#formulario") as any).validate({
    rules: {
      txtCodigo: {
        required: true
      },
      txtNome: {
        required: true
      },
      txtDescricaoEmpresa: {
        required: true
      }
    },
    messages: {
      txtCodigo: {
        required: "Informe o Código"
      },
      txtNome: {
        required: "Informe o Nome"
      },
      txtDescricaoEmpresa: {
        required: "Informe a Descrição da Empresa"
      }
    },
  });

  ($("#formulario") as any).on("submit", function () {
    return false;
  });
}

  getIntitialsData() {
    this.loadDataTable([]);
  }

  getDataGrid() {
    const data = this.getValuesFromInput();
    this.moduleService.pesquisar(data).subscribe(
      res => {
        this.gridData = res.map(val =>
  ({
    id: val.Id,
    codigo: val.Codigo,
    nome: val.Nome,
    descricaoEmpresa: val.DescricaoEmpresa, // Novo campo
    dataCadastro: val.DataCadastro,
  })
).sort(this.utilService.dynamicSort('nome'));
        this.loadDataTable(this.gridData);
      },
      err => {
        console.log(err);
      }
    );
  }

  clearInputvalues() {
  this.isEdit = false;
  $('#txtNome').val('');
  $('#txtCodigo').val('');
  $('#txtDescricaoEmpresa').val('');
}

 getValuesFromInput() {
  return {
    Nome: $('#txtNome').val().toString().trim(),
    Codigo: $('#txtCodigo').val().toString().trim(),
    DescricaoEmpresa: $('#txtDescricaoEmpresa').val().toString().trim()
  }
}

  pesquisar() {
    this.getDataGrid();
  }

  salvar() {
    if (($("#formulario") as any).valid()) {
      const obj: any = this.getValuesFromInput();
      if (this.isEdit) {
        obj.Id = this.unidadeIdSelected;
        this.moduleService.editar(obj).subscribe(
          res => {
            if (res.Codigo && res.Codigo == '600') {
              Swal.fire({
                position: 'top',
                icon: 'error',
                title: res.Descricao || 'Ocorreu um erro',
                showConfirmButton: false,
                timer: 2000
              });
            } else {
              this.clearInputvalues();
              this.getDataGrid();
              this.utilService.alertSwal('edit-success');
            }
          },
          err => {
            console.log(err);
            this.utilService.alertSwal('edit-error');
          }
        );
      } else {
        this.moduleService.adicionar(obj).subscribe(
          res => {
            if (res.Codigo && res.Codigo == '600') {
              Swal.fire({
                position: 'top',
                icon: 'error',
                title: res.Descricao || 'Ocorreu um erro',
                showConfirmButton: false,
                timer: 2000
              });
            } else {
              this.clearInputvalues();
              this.getDataGrid();
              this.utilService.alertSwal('add-success');
            }
          },
          err => {
            console.log(err);
            this.utilService.alertSwal('add-error');
          }
        );
      }
    }
  }

  destroiTable() {
    this.dataTable = $(this.grid.nativeElement);
    if (this.dataTable.hasClass('dataTable')) {
      var tableFound = this.dataTable.DataTable();
      tableFound.destroy();
    }
  }

  loadDataTable(data) {
    let self = this;
    this.dataTable = $(this.grid.nativeElement);
    this.dataTable.DataTable({
      "data": data,
      "bDestroy": true,
      "columns": [
  {
    "data": "codigo"
  },
  {
    "data": "nome"
  },
  {
    "data": "descricaoEmpresa" // <-- Novo campo na tabela
  },
  {
    "data": 'dataCadastro', "orderable": true, "render": function (data) {
      return data ? new Date(data).toLocaleDateString('pt-br') : '-';
    }
  },
  {
    "data": '', "orderable": false, "render": function () {
      return '<div style="text-align:center;"><button type="button" class="fa fa-edit" style="color:rgb(136, 134, 29); border:0; background:transparent;" title="Editar"></button></div>';
    }
  },
  {
    "data": '', "orderable": false, "render": function () {
      return '<div style="text-align:center;"><button type="button" class="fa fa-trash-o" style="color:rgb(206, 14, 14); border:0; background:transparent;" title="Excluir"></button></div>';
    }
  }
],
     "createdRow": function (row, data, index) {
  $($(row).children()[4]).on("click", function () {
    self.isEdit = true;
    $('#txtCodigo').val(data.codigo);
    $('#txtNome').val(data.nome);
    $('#txtDescricaoEmpresa').val(data.descricaoEmpresa);
    self.unidadeIdSelected = data.id;
  });

  $($(row).children()[5]).on("click", function () {
    self.remover(data);
  });
},
      "paging": true,
      "bAutoWidth": false,
      "lengthChange": true,
      "searching": true,
      "ordering": true,
      "info": true,
      "autoWidth": true,
      "language": this.utilService.getDatatableTranslate(),
    });
  }

}
